export const PaymentModalStyle = {
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		margin: '40px auto 16px',
		padding: '12px 16px',
		maxWidth: '374px',
		width: '100%',
	},
};
